import {Guide} from './guide';

export class PaginatedGuides {
  guides: Guide[];

  constructor(g: Guide[]) {
    this.guides = g;
  }
}
